import { CommonModule } from '@angular/common';
import { Component, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { PUBLIC_ASSET_PATH } from '@features/auth/const';
import { VerifyAccountFirstLoginService } from '@features/auth/core/domain/account-first-login/verify-account-first-login.service';
import { AuthLayoutComponent } from '@features/auth/shared/components/auth-layout/auth-layout.component';
import { DeviceInfoHelper } from '@features/auth/shared/helpers/device-info.helper';
import { TranslocoModule } from '@ngneat/transloco';
import { finalize } from 'rxjs';

@Component({
  standalone: true,
  imports: [CommonModule, AuthLayoutComponent, TranslocoModule],
  selector: 'app-verify-device',
  templateUrl: './verify-device.component.html',
  styleUrls: ['./verify-device.component.css'],
})
export class VerifyDeviceComponent implements OnInit {
  service = inject(VerifyAccountFirstLoginService);
  routing = inject(Router);

  constructor() {}

  ngOnInit() {}

  iconPath = PUBLIC_ASSET_PATH + '/img/device.png';

  errorMessage = '';
  isFirstSend: boolean = false;

  device = DeviceInfoHelper.getSimple();

  onVerify() {
    this.isFirstSend = true;
    this.errorMessage = '';
    this.service
      .sendVerifyDeviceCode()
      .pipe(
        finalize(() => {
          setTimeout(() => {
            this.isFirstSend = false;
          }, 300);
        })
      )
      .subscribe({
        next: (value) => {
          this.routing.navigate(['cap-nhat-thong-tin', 'v'], {
            queryParams: {
              t: 'device',
            },
          });
        },
        error: (err) => {
          console.error(err);
          this.errorMessage = err.message;
        },
      });
  }

  navigateToLogin() {
    this.routing.navigate(['login']);
  }
}
